module.exports = __webpack_public_path__ + "img/promolider_logo_2.aecc2419.png";